import { Skeleton, Table } from '@mantine/core';
import { KeyedRow } from './KeyedRow';

interface LoadingRowsProps {
	isLoading?: boolean;
	columnSpan?: number;
	rows: number;
}

export function LoadingRows({
	isLoading = true,
	columnSpan = 100,
	rows,
}: LoadingRowsProps) {
	const loadingIndicators = [...Array(isLoading ? rows : 0)].map((_, index) => (
		// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
		<KeyedRow key={index}>
			<Table.Td colSpan={columnSpan}>
				<Skeleton w={'100%'} h={32} />
			</Table.Td>
		</KeyedRow>
	));

	return <>{isLoading && loadingIndicators}</>;
}
